const applicationRoutes = [
  // {
  //   path: '/test-page',
  //   name: 'TestPage',
  //   component: () => import('./pages/my-applications.vue'),
  //   meta: {
  //     requiresAuth: true,
  //   },
  // },
];

export default applicationRoutes;
